import { render } from "./ProducedGasComponentChart.vue?vue&type=template&id=dd368160"
import script from "./ProducedGasComponentChart.vue?vue&type=script&lang=js"
export * from "./ProducedGasComponentChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__